import axios from "axios";
import { baseURL } from "@/general";
axios.defaults.baseURL = baseURL;
import {
  userLogin,
  insertPeriodo,
  getSemestres,
  updatePeriodo,
  getProfesores,
  insertProfesores,
  updateProfesor,
  updateEstatus,
  getCatalogoAlumnos,
  getAlumnos,
  getDependencias,
  insertAlumnos,
  updateEstatusAlumnos,
  updateAlumno,
  getGrupos,
  insertGrupo,
  updateGrupo,
  getSemestre,
  insertExamenTitulacion,
  insertMasiveNivel,
  getExamenTitulacion,
  getNiveles,
  updateNivelInicial,
  updateExamenTitulacion,
  updateEstatusExamenTitulacion,
  updateMasiveAlumnos,
  updateMasiveProfesores,
  insertAlumnoExamen,
  sendConstanciaMassive,
  sendConstancia,
  pagoAlumnoExamen,
  calificarAlumnoExamen,
  validateAlumno,
  updateFechasExamenTitulacion,
  validateProfesor,
  resetPasword,
  getAsignaturas,
  getCatalogoProfesores,
  updatePeriodoInscripcion,
  getPeriodosInscripcion,
  insertPeriodoInscripcion,
  getSemestreActual,
  getPreguntas,
  insertPreguntaEncuesta,
  getCategoriaEncuesta,
  insertCategoriaEncuesta,
  cambiarEstatusCategoria,
  editCategoriaEncuesta,
  getValidaEncuesta,
  insertSemestreEncuesta,
  updateEstatusPregunta,
  getInscritosGrupos,
  getCatalogoGruposByPeriodo,
  insertInscripcion,
  pagoInscripcion,
  calificarAlumnoInscripcion,
  updateInscripcion,
  getListaInscritos,
  getSalones,
  liberarVacantes,
  verificaAcceso,
  validaAvisoPrivacidad,
  confirmaAvisoPrivacidad,
  resetPassword,
  getRecursosVisuales,
  insertRecursoVisual,
  updateEstatusRecursoVisual,
  updateRecursoVisual,
  generarFormatoPagoService,
  getFechasExamenByTyipo,
  getCatalogoFechasExamenByTyipo,
  deleteFechaExamen,
  getCatalogoCategoriaEncuesta,
  addPreguntaComplementaria,
  changeOrdenPreguntasComplementarias,
  changeOrdenPreguntas,
  getVisualizarEncuesta,
  getRegistrosExamenesByFecha,
  getListaRegistrosExamen,
  getHistoriaAcademica,
  changeIdiomaPreguntas,
  getCatalogoMaestriasPosgrados,
  envioConstanciasMaestriaPosgrado,
  getReporteEncuesta,
  restorePassword,
  setNewPassword,
  verifytoken,
  changeAdminPassword,
  cancellInscripcion,
  downloadConstancia,
} from "@/modules/admin/helpers/services";
export const revisaAcceso = async ({ commit }, values) => {
  const { data } = await verificaAcceso(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const obtenAvisoPrivacidad = async ({ commit }, values) => {
  const { data } = await validaAvisoPrivacidad(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const aceptaAvisoPrivacidad = async ({ commit }, values) => {
  const { data } = await confirmaAvisoPrivacidad(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const resetContraseña = async ({ commit }, values) => {
  const { data } = await resetPassword(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const verificaSesion = async ({ commit }, values) => {
  const { data } = await verificaAcceso(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
////Encuestas
export const traePreguntas = async ({ commit }, values) => {
  const { data } = await getPreguntas(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraPreguntaEncuesta = async ({ commit }, values) => {
  const { data } = await insertPreguntaEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const agregaPreguntaComplementaria = async ({ commit }, values) => {
  const { data } = await addPreguntaComplementaria(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarOrdenPreguntasComplementarias = async (
  { commit },
  values
) => {
  const { data } = await changeOrdenPreguntasComplementarias(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarOrdenPreguntas = async ({ commit }, values) => {
  const { data } = await changeOrdenPreguntas(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const actualizaEstatusPregunta = async ({ commit }, values) => {
  const { data } = await updateEstatusPregunta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeCategoriaEncuesta = async ({ commit }) => {
  const { data } = await getCategoriaEncuesta();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Se utiliza para la vista de las preguntas de la encuesta

export const traeCatalogoCategoriaEncuesta = async ({ commit }) => {
  const { data } = await getCatalogoCategoriaEncuesta();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const registraCategoriaEncuesta = async ({ commit }, values) => {
  const { data } = await insertCategoriaEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const editaCategoriaEncuesta = async ({ commit }, values) => {
  const { data } = await editCategoriaEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const cambiaEstatusCategoria = async ({ commit }, values) => {
  const { data } = await cambiarEstatusCategoria(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const validaEncuesta = async ({ commit }) => {
  const { data } = await getValidaEncuesta();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraSemestreEncuesta = async ({ commit }) => {
  const { data } = await insertSemestreEncuesta();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeEncuesta = async ({ commit }, values) => {
  const { data } = await getVisualizarEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const generaReporteEncuesta = async ({ commit }, values) => {
  const { data } = await getReporteEncuesta(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


//Inicio Sesion
export const verifyUser = async ({ commit }, values) => {
  const { data } = await userLogin(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Semestre
export const traeSemestreActual = async ({ commit }) => {
  const { data } = await getSemestreActual();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeSemestre = async ({ commit }, values) => {
  const { data } = await getSemestre(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeTodosSemestres = async ({ commit }) => {
  const { data } = await getSemestres();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const creaPeriodo = async ({ commit }, values) => {
  const { data } = await insertPeriodo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaPeriodo = async ({ commit }, values) => {
  const { data } = await updatePeriodo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

//Profesores
export const traeCatalogoProfesores = async ({ commit }) => {
  const { data } = await getCatalogoProfesores();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeProfesores = async ({ commit }) => {
  const { data } = await getProfesores();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraProfesores = async ({ commit }, values) => {
  const { data } = await insertProfesores(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaProfesor = async ({ commit }, values) => {
  const { data } = await updateProfesor(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const updateEstatusProfesor = async ({ commit }, values) => {
  const { data } = await updateEstatus(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaMasiveProfesores = async ({ commit }, values) => {
  const { data } = await updateMasiveProfesores(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const validarProfesor = async ({ commit }, values) => {
  const { data } = await validateProfesor(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
// Alumnos
export const traeCatalogoAlumnos = async ({ commit },values) => {
  const { data } = await getCatalogoAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeAlumnos = async ({ commit },values) => {
  const { data } = await getAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraAlumnos = async ({ commit }, values) => {
  const { data } = await insertAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const updateEstatusAlumno = async ({ commit }, values) => {
  const { data } = await updateEstatusAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaAlumno = async ({ commit }, values) => {
  const { data } = await updateAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaMasiveAlumnos = async ({ commit }, values) => {
  const { data } = await updateMasiveAlumnos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const validaAlumno = async ({ commit }, values) => {
  const { data } = await validateAlumno(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Grupos
export const traeGrupos = async ({ commit }, values) => {
  const { data } = await getGrupos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraGrupo = async ({ commit }, values) => {
  const { data } = await insertGrupo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaGrupo = async ({ commit }, values) => {
  const { data } = await updateGrupo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeCatalogoGruposByPeriodo = async ({ commit }, values) => {
  const { data } = await getCatalogoGruposByPeriodo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const generaListaInscritos = async ({ commit }, values) => {
  const { data } = await getListaInscritos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const liberarVacantesGrupo = async ({ commit }, values) => {
  const { data } = await liberarVacantes(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const traeSalones = async ({ commit }) => {
  const { data } = await getSalones();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// INSCRIPCION A GRUPOS
export const traeInscritos = async ({ commit }, values) => {
  const { data } = await getInscritosGrupos(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const inscribirAlumno = async ({ commit }, values) => {
  const { data } = await insertInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarAlumnoInscripcion = async ({ commit }, values) => {
  const { data } = await updateInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const procesaPagoInscripcion = async ({ commit }, values) => {
  const { data } = await pagoInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const procesaCalificacionInscripcion = async ({ commit }, values) => {
  const { data } = await calificarAlumnoInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Examen de titulacion
export const registraExamenTitulacion = async ({ commit }, values) => {
  const { data } = await insertExamenTitulacion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeExamenTitulacion = async ({ commit }) => {
  const { data } = await getExamenTitulacion();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaExamenTitulacion = async ({ commit }, values) => {
  const { data } = await updateExamenTitulacion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaEstatusExamenTitulacion = async ({ commit }, values) => {
  const { data } = await updateEstatusExamenTitulacion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraAlumnoExamen = async ({ commit }, values) => {
  const { data } = await insertAlumnoExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const traeRegistrosExamenByFecha = async ({ commit }, values) => {
  const { data } = await getRegistrosExamenesByFecha(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaPagoAlumnoExamen = async ({ commit }, values) => {
  const { data } = await pagoAlumnoExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaCalificacionAlumnoExamen = async ({ commit }, values) => {
  const { data } = await calificarAlumnoExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Acciones para administrar fechas del examen de titulacion

// Insertar o editar fechas
export const actualizaFechasExamenTitulacion = async ({ commit }, values) => {
  const { data } = await updateFechasExamenTitulacion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Trae todas las fechas del examen y sus dias de registro segun el tipo
export const traerFechasExamenTitulacion = async ({ commit }, values) => {
  const { data } = await getFechasExamenByTyipo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Trae solo las fechas del dia del examen segun el tipo
export const traerCatalogoFechasExamenTitulacion = async (
  { commit },
  values
) => {
  const { data } = await getCatalogoFechasExamenByTyipo(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

//Eliminar fechas del examen by id
export const eliminarFechaExamenTitulacion = async ({ commit }, values) => {
  const { data } = await deleteFechaExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Actualizar nivel idioma
export const registraMasiveNivel = async ({ commit }, values) => {
  const { data } = await insertMasiveNivel(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaNivel = async ({ commit }, values) => {
  const { data } = await updateNivelInicial(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Catalogos
//// Obtiene las dependencias UNAM
export const traeDependencias = async ({ commit }) => {
  const { data } = await getDependencias();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Asignaturas
//// Obtiene las dependencias UNAM
export const traeAsignaturas = async ({ commit }) => {
  const { data } = await getAsignaturas();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
//// Obtiene los Niveles existentes
export const traeNiveles = async ({ commit }) => {
  const { data } = await getNiveles();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

//Periodos de inscripcion
export const traePeriodosInscripcion = async ({ commit }) => {
  const { data } = await getPeriodosInscripcion();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const actualizaPeriodoInscripcion = async ({ commit }, values) => {
  const { data } = await updatePeriodoInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const registraPeriodoInscripcion = async ({ commit }, values) => {
  const { data } = await insertPeriodoInscripcion(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

//Auxiliares
export const enviarConstanciaMasivo = async ({ commit }, values) => {
  const { data } = await sendConstanciaMassive(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};





export const descargarListaRegistrosExamenes = async ({ commit }, values) => {
  const { data } = await getListaRegistrosExamen(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};
export const enviarConstancia = async ({ commit }, values) => {
  const { data } = await sendConstancia(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const descargarConstancia = async ({ commit }, values) => {
  const { data } = await downloadConstancia(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const reiniciaPassword = async ({ commit }, values) => {
  const { data } = await resetPassword(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// Recursos Visuales
export const traeRecursosVisuales = async ({ commit }) => {
  const { data } = await getRecursosVisuales();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const insertarRecursoVisual = async ({ commit }, values) => {
  const { data } = await insertRecursoVisual(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarRecursoVisual = async ({ commit }, values) => {
  const { data } = await updateRecursoVisual(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarEstatusRecursoVisual = async ({ commit }, values) => {
  const { data } = await updateEstatusRecursoVisual(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const generarFormatoPago = async ({ commit }, values) => {
  const { data } = await generarFormatoPagoService(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const generarHistoriaAcademica = async ({ commit }, values) => {
  const { data } = await getHistoriaAcademica(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const cambiarIdiomaPreguntas = async ({ commit }, values) => {
  const { data } = await changeIdiomaPreguntas(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// PARA EL ENVIO DE CONSTANCIAS DE MAESTRIA DOCTORADO
export const traeCatalogoMaestriasDoctorados = async ({ commit }) => {
  const { data } = await getCatalogoMaestriasPosgrados();
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

export const enviarConstanciasMaestriaPosgrado = async ({ commit }, values) => {
  const { data } = await envioConstanciasMaestriaPosgrado(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};

// PARA CAMBIO O RESTAURAR CONTRASEÑA DE ADMIN
export const restorePasswordAdmin = async ({ commit }, values) => {
  const response = await restorePassword(values);
  return response;
}

export const validarTokenAdmin = async ({ commit }, values) => {
  const response = await verifytoken(values);
  return response;
}

export const setearNuevaPasswordAdmin = async ({ commit }, values) => {
  const response = await setNewPassword(values);
  return response;
}

export const changeAdminPasswd = async ({ commit }, values) => {
  const response = await changeAdminPassword(values);
  return response;
}

export const cancelarInscripcion = async ({commit}, values) => {
  const response = await cancellInscripcion(values);
  return response;
}
